import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IRouteOperationPropertyCS {
    csRouteID: number;
    dataAreaID: string;
    operationId: string;
    operationNumber: number;
    operationPriority: number;
    itemNumber: string;
    routeId: string;
    productionSiteId: string;
    processQuantity: number;
    quantityCostCategoryId: string;
    routeGroupId: string;
    loadPercentage: number;
    resourceQuantity: number;
    setupTime: number;
    queueTimeBefore: number;
    costingOperationResourceId: string;
    queueTimeAfter: number;
    processTime: number;
    setupCostCategoryId: string;
    routeType: string;
    transitTime: number;
    processCostCategoryId: string;
}

export const getRouteOperationPropertiesCS = async (
    csRouteID: number,
): Promise<IRouteOperationPropertyCS[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IRouteOperationPropertyCS[]>(
        `/RouteOperation/GetRouteOperationPropertiesCS/${csRouteID}`,
    );
    return response.data;
};
